export default __webpack_public_path__ + "static/media/integration.c2bc6dd8.svg";